import { siteData } from "../data/mock";
import { MessageCircle, Star, Clock, MapPin, Award } from "lucide-react";

export const HeroSection = () => {
  return (
    <section
      id="inicio"
      className="relative min-h-screen flex items-center overflow-hidden"
      style={{ backgroundColor: '#1F1F1F' }}
    >
      {/* Background image with strong overlay */}
      <div className="absolute inset-0">
        <img
          src={siteData.images.explaining}
          alt="Dra. Giovana Gamborgi - Clínica Odontológica"
          className="w-full h-full object-cover"
        />
        <div
          className="absolute inset-0"
          style={{ background: 'linear-gradient(to right, rgba(31,31,31,0.93) 0%, rgba(31,31,31,0.80) 50%, rgba(31,31,31,0.55) 100%)' }}
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 lg:py-0 w-full">
        <div className="max-w-3xl">
          {/* Social Proof Stars */}
          <div className="flex items-center gap-2 mb-5">
            <div className="flex">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star key={i} size={20} fill="#85BCFF" style={{ color: '#85BCFF' }} />
              ))}
            </div>
            <span className="text-sm font-semibold" style={{ color: '#85BCFF' }}>
              {siteData.hero.socialProof.rating} • {siteData.hero.socialProof.reviews} avaliações
            </span>
          </div>

          {/* Headline */}
          <h1
            className="text-4xl sm:text-5xl lg:text-[3.5rem] font-bold mb-6 leading-tight"
            style={{ color: '#FEFEFE' }}
          >
            {siteData.hero.headline.split("sorrisos").map((part, i) =>
              i === 0 ? (
                <span key={i}>
                  {part}<span style={{ color: '#85BCFF' }}>sorrisos</span>
                </span>
              ) : (
                <span key={i}>{part}</span>
              )
            )}
          </h1>

          {/* Subheadline */}
          <p
            className="text-lg sm:text-xl mb-8 leading-relaxed max-w-2xl"
            style={{ color: 'rgba(254, 254, 254, 0.75)' }}
          >
            {siteData.hero.subheadline}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 mb-10">
            <a
              href={siteData.brand.whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-lg text-base font-bold transition-all duration-200 hover:scale-105 hover:shadow-xl"
              style={{ backgroundColor: '#85BCFF', color: '#1F1F1F' }}
            >
              <MessageCircle size={20} />
              {siteData.hero.ctaText}
            </a>
            <a
              href="#especialidades"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-lg text-base font-bold transition-all duration-200 hover:bg-white/10"
              style={{ border: '2px solid rgba(133, 188, 255, 0.4)', color: '#FEFEFE' }}
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#especialidades')?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              Ver Especialidades
            </a>
          </div>

          {/* Info pills */}
          <div className="flex flex-wrap gap-5 text-sm">
            <div className="flex items-center gap-2" style={{ color: 'rgba(254,254,254,0.8)' }}>
              <Clock size={18} style={{ color: '#85BCFF' }} />
              <span>Seg–Sex: 08:30–18:00</span>
            </div>
            <div className="flex items-center gap-2" style={{ color: 'rgba(254,254,254,0.8)' }}>
              <MapPin size={18} style={{ color: '#85BCFF' }} />
              <span>Chapecó – SC</span>
            </div>
            <div className="flex items-center gap-2" style={{ color: 'rgba(254,254,254,0.8)' }}>
              <Award size={18} style={{ color: '#85BCFF' }} />
              <span>Invisalign Top Doctor</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
